export const AdminNavigationPaths = [
  {
    key: "ADMIN",
    sortOrder: 1,
    url: "/admin/add-products",
    title: "Products Administration",
    child_items: [
      {
        key: "ADMIN",
        sortOrder: 1,
        child_url: "/admin/add-products",
        child_title: "Add a New Product",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 2,
        child_url: "/admin/edit-products",

        child_title: "Edit Product",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 3,
        child_url: "/admin/affiliate-product-visibility",

        child_title: "Affiliate Product Visbility",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 4,
        child_url: "/admin/indications",

        child_title: "Add/Remove Product Indications",
        child_items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 5,
        child_url: "/admin/new-manage-indications",

        child_title: "Manage Indications",
        items: [],
      },
    ],
  },
  {
    key: "ADMIN",
    sortOrder: 2,
    url: "/admin/manage-tet-products",

    title: "Temperature Excursion",
    child_items: [
      {
        key: "ADMIN",
        sortOrder: 1,
        child_url: "/admin/add-tet-product",

        child_title: "Add TET Product",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 2,
        child_url: "/admin/manage-tet-products",

        child_title: "Manage TET Products",
        enabled: true,
        type: "Internal Site",
        target: "_self",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 3,
        child_url: "/admin/manage-tet-rule",

        child_title: "Manage TET Rule Configurations",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 4,
        child_url: "/admin/manage-tet-content",

        child_title: "Manage TET Content",
        items: [],
      },
    ],
  },
  {
    key: "ADMIN",
    sortOrder: 3,
    url: "/admin/manage-translations-draft",

    title: "Translations",
    child_items: [
      {
        key: "ADMIN",
        sortOrder: 1,
        child_url: "/admin/manage-translations-draft",

        child_title: "Manage Translations Draft",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 2,
        child_url: "/admin/edit-translations-draft",

        child_title: "Edit Translations in Draft",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 3,
        child_url: "/admin/manage-translations-live",

        child_title: "Manage Translations Live",
        items: [],
      },
    ],
  },
  {
    key: "ADMIN",
    sortOrder: 4,
    url: "/admin/create-static-page",

    title: "Content Management",
    child_items: [
      {
        key: "ADMIN",
        sortOrder: 1,
        child_url: "/admin/create-static-page",

        child_title: "Create Static Page",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 2,
        child_url: "/admin/manage-static-page",

        child_title: "Manage Static Pages",
        items: [],
      },

      {
        key: "ADMIN",
        sortOrder: 3,
        child_url: "/admin/adgroups",

        child_title: "Manage Search AD Groups",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 4,
        child_url: "/admin/manage-congresses",

        child_title: "Manage Congresses",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 5,
        child_url: "/admin/manage-site-messages",

        child_title: "Manage Site Messages",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 6,
        child_url: "/admin/manage-country-menu",

        child_title: "Manage Country Menu / Functionalities",
        items: [],
      },
    ],
  },
  {
    key: "ADMIN",
    sortOrder: 5,
    url: "/admin/ami_chatbot_admin",

    title: "Chatbot",
    child_items: [
      {
        key: "ADMIN",
        sortOrder: 1,
        child_url: "/admin/ami_chatbot_admin",

        child_title: "AMI Chatbot Admin",
        items: [],
      },
    ],
  },

  {
    key: "ADMIN",
    sortOrder: 6,
    url: "/admin/site-export",

    title: "Data Management",
    child_items: [
      {
        key: "ADMIN",
        sortOrder: 1,
        child_url: "/admin/site-export",

        child_title: "Export Content",
        items: [],
      },
      {
        key: "ADMIN",
        sortOrder: 2,
        child_url: "/admin/audit_history",

        child_title: "Audit History",
        items: [],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/adminNavigationPaths.js